const SeePricingButton = ({ onClick }) => (
  <button
    type="button"
    onClick={e => {
      e.stopPropagation();
      onClick();
    }}
    style={{
      cursor: 'pointer',
      border: '1px solid rgba(82, 103, 255, 1)',
      color: 'rgba(82, 103, 255, 1)',
      background: 'white',
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: '12px',
      fontWeight: 500,
      whiteSpace: 'nowrap'
    }}
  >
    See pricing
  </button>
);

export default SeePricingButton;
